import React, { Component } from 'react';
import './CartStyles.css'
import CartItem from './CartItem';

class ShoppingCart extends Component {



    render() {
        return (
            <div className="container">
                <div className="card shopping-cart main-shadow">
                    <div className="card-header bg-main text-light ">
                        <i className="fa fa-shopping-cart" />
                 &nbsp;Shopping cart
                <button className="btn btn-outline-info text-white pull-right">Continue shopping</button>
                        <div className="clearfix" />
                    </div>
                    <div className="card-body">
                        <CartItem />
                        <CartItem />
                        <CartItem />
                        <CartItem />


                    </div>
                    <div className="card-footer">
                        <div className="coupon col-md-5 col-sm-5 no-padding-left pull-left">
                            <div className="row">
                                <div className="col-6">
                                    <input type="text" className="form-control" placeholder="cupone code" />
                                </div>
                                <div className="col-6">
                                    <input type="submit" className="btn btn-default" defaultValue="Use cupone" />
                                </div>
                            </div>
                        </div>
                        <div className="pull-right" style={{ margin: '10px' }}>
                            <div className="pull-right txt-main" style={{ margin: '5px',fontSize:'32px' }}>
                                Total price: <b>Rs.50.00</b>
                            </div>
                        </div>
                        <br />

                    </div>
                    <button  className="btn btn-checkout">Checkout</button>
                </div>
            </div>

        );
    }
}

export default ShoppingCart;
